// extracted by mini-css-extract-plugin
export default {"container":"hK-z","topReviewHeading":"iK-z","criticalReview":"jK-z","favorableReview":"kK-z","vsSeparator":"lK-z"};